import React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import "./styles.css";

export const Label = React.forwardRef((props, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className="custom-signal-com-required-label"
    {...props}
  />
));